const ConflictDictionary = () =>
  import(
    /* webpackChunkName: "reports-conflict" */ '@/pages/report/dictionary/internal.vue'
  )

const ConflictExternal = () =>
  import(
    /* webpackChunkName: "reports-conflict" */ '@/pages/report/dictionary/external.vue'
  )

export default {
  path: 'dictionary',
  meta: {
    label: '',
    auth: 'conflict'
  },
  component: {
    name: 'Conflict',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'ReportConflictDictionary',
      path: 'internal',
      meta: {
        title: 'nav.conflictWithReferenceSystem',
        auth: 'internal'
      },
      component: ConflictDictionary
    },
    {
      name: 'ReportConflictExternal',
      path: 'external',
      meta: {
        title: 'nav.conflictWithExternalSystem',
        auth: 'external'
      },
      component: ConflictExternal
    }
  ]
}
